import {createSelector} from '@reduxjs/toolkit'
import {addDays} from 'date-fns/addDays'
import {format} from 'date-fns/format'
import {getCurrencyCode} from 'modules/meta/selectors'
import {AppThunk} from 'store'

import {priceInsightsApi, type PricePredictionParams} from './priceInsightsApi'

const PRICE_PREDICTION_DEFAULT_DAYS_AHEAD = 60
const PRICE_PREDICTION_DEFAULT_ROOM_CONFIGURATION = 2
const PRICE_PREDICTION_DEFAULT_NIGHTS = 1

const getHotelIdParam = (_, hotelId: string | number) => hotelId

export const getPricePredictionParam = createSelector(
  [getCurrencyCode, getHotelIdParam],
  (currency, hotelId): PricePredictionParams => {
    const today = new Date()
    const calendarFromDate = addDays(today, -1)
    const calendarToDate = addDays(today, PRICE_PREDICTION_DEFAULT_DAYS_AHEAD)

    return {
      currency,
      hotelId,
      fromCheckIn: format(calendarFromDate, 'yyyy-MM-dd'),
      toCheckIn: format(calendarToDate, 'yyyy-MM-dd'),
      roomConfiguration: String(PRICE_PREDICTION_DEFAULT_ROOM_CONFIGURATION),
      nights: PRICE_PREDICTION_DEFAULT_NIGHTS
    }
  }
)

export const preloadPricePrediction =
  (hotelId: string): AppThunk<void> =>
  (dispatch, getState) => {
    const params = getPricePredictionParam(getState(), hotelId)
    return dispatch(
      priceInsightsApi.endpoints.getPricePrediction.initiate(params)
    )
  }
